import React from "react";
import Seo from "../components/Seo";
import Loading from "../components/Loading";
import "../css/Documentation.css";
import {BrokerBenchmark, parseBrokerResult} from "../components/BrokerBenchmark";
import p2pUrl from "../xmq_test_results/Point-To-Point.txt";

export default class XMQ_tests_p2p extends React.Component
{
    state = {servers: null, error: null};

    componentDidMount()
    {
        fetch(p2pUrl)
            .then((r) => r.text())
            .then((text) => this.setState({servers: parseBrokerResult(text)}))
            .catch((err) => this.setState({error: String(err)}));
    }

    render()
    {
        const {servers, error} = this.state;

        return <div key="tests-p2p" className="XMQ" style={{textAlign: "left", padding: 8}}>
            <Seo title="MQTT Performance Tests — Point-to-Point"
                 description="MQTT point-to-point benchmark: 50,000 publisher-subscriber pairs at 100,000 messages a second measure QoS 1 throughput and end-to-end latency."
                 keywords="MQTT performance tests, fast MQTT server, MQTT benchmark, XMQ"
                 path="/xmq_tests_p2p"/>
            <h1>MQTT Performance Tests: Point-to-Point</h1>
            <h3>Point-to-Point: One-to-One Messaging</h3>

            <p>
                Models direct device-to-device traffic. Each of 50,000 publishers has one
                subscriber on its own topic and sends it two messages a second. At QoS&nbsp;1, the
                test measures end-to-end delivery latency at 100,000 messages/second over 100,000
                connections. Every broker runs the same workload.
            </p>

            <p>
                XMQ 1.0.2 and FlashMQ 1.27.2 were re-measured on 2 November 2026 on the same
                c5n.4xlarge host (16 vCPU, 40 GB) as the other brokers here. Percentiles are
                shown where the run recorded them; a dash means its result file has no percentile
                section.
            </p>

            {error && <p>Failed to load test results: {error}</p>}
            {!servers && !error && <Loading text="Loading results…"/>}

            <BrokerBenchmark servers={servers} targetRate={100000}/>
        </div>;
    }
}
